import React from 'react';
import { IconClose, IconFilter, IconSearch } from '../icons/svg';

import { Tinode } from '../tinode/tinode';

export default class SearchContacts extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      edited: false,
      search: '',
      hiddenMessages: false,
      unreadTopic: 0
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMessageHide = this.handleMessageHide.bind(this);
    this.getClassIconSearchHide = this.getClassIconSearchHide.bind(this);
    this.getUnreadTopicHide = this.getUnreadTopicHide.bind(this);
    this.setChatSearchRef = this.setChatSearchRef.bind(this);

    this.pressTimer = null;
  }

  componentDidMount() {
    if (this.props.tinode) {
      this.props.tinode.onMessageHide = this.handleMessageHide
    }
    this.getUnreadTopicHide()
  }

  componentDidUpdate(prevProps) {
    if (this.props.chatList != prevProps.chatList) {
      this.getUnreadTopicHide()
    }

    if (this.props.topicSelected !== prevProps.topicSelected) {
      this.handleClear();
    }
  }

  componentWillUnmount() {
    if (this.state.edited) {
      this.setState({ search: '', edited: false });
      this.props.onSearchContacts(Tinode.DEL_CHAR);
    }
  }

  setChatSearchRef(ref) {
    this.props.tinode.searchChatEditArea = ref
  }

  handleSearchChange(e) {
    const query = e.target.value
    this.setState({ search: query });

    this.handleSearch(query)
  }

  handleSearch(query) {
    this.setState({ edited: (query.length > 0) });
    this.props.onSearchContacts(query.length > 0 ? query : Tinode.DEL_CHAR);
  }

  handleClear() {
    if (this.state.edited) {
      this.props.onSearchContacts(Tinode.DEL_CHAR);
    }
    this.setState({ search: '', edited: false });
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') {
      this.handleClear();
    }
    // this.handleSearch(e);
  }

  handleMessageHide(msg) {
    clearTimeout(this.pressTimer);
    this.pressTimer = setTimeout(_ => this.setState({ hiddenMessages: false }), 2000);
    if (!this.state.hiddenMessages) {
      this.setState({ hiddenMessages: true });
    }
  }

  getClassIconSearchHide() {
    let classList = ''
    if (this.state.hiddenMessages) {
      classList = classList + ' zoom-in-zoom-out-search-hide';
    }

    if (this.state.unreadTopic > 0) {
      classList = classList + ' search-hide-active'
    }
    return classList;
  }

  getUnreadTopicHide() {
    const { chatList } = this.props;
    if (chatList) {
      let total = chatList.reduce((n, c) => {
        if (c.isHide) {
          return n + c.unread;
        }
        return n;
      }, 0);
      this.setState({
        unreadTopic: total
      })
    }
  }

  render() {
    return (
      <div className="" id="search-control">
        <div className="panel-form">
          <div className="panel-form-row">
            <i className={`icon ${this.getClassIconSearchHide()}`}><IconSearch /></i>
            <input className="search" type="text"
              ref={(ref) => { this.setChatSearchRef(ref) }}
              placeholder={this.props.placeholder}
              value={this.state.search} onChange={this.handleSearchChange}
              onKeyDown={this.handleKeyDown} required autoFocus 
              title=''
              />
            {(this.state.search.length > 0) &&
              <i className="icon-close" onClick={this.handleClear}><IconClose /></i>
            }
          </div>
        </div>

      </div>
    );
  }
};
